module.exports = __webpack_public_path__ + "static/media/folder-outline.bb8e0266.svg";